module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#user",
      toString: function () {
        return this.url;
      }
    }